import { isEmpty } from 'ramda'


type UnperformedDto = {
  schools: Array<{
    school_id: number
    school_title: string
  }>
}

export const convertUnperformed = (unperformedDto: UnperformedDto) => {
  const { schools } = unperformedDto
  if (schools && !isEmpty(schools)) {
    return (
      schools
        .map(({ school_id: id, school_title: title }) => ({
          ID: String(id),
          title: String(title),
        }))
        .sort((a, b) => a.title.localeCompare(b.title))
    )
  }
  return [] as Array<{ ID: string, title: string }>
}
